import type { AxiosInstance } from 'axios'

// TODO: patch, put - if it'll be needed
interface IHttpService {
  get<T>(url: string, data?: object): Promise<T>
  post<T>(url: string, data?: object | string): Promise<T>
  abortRequests(): void
}
class HttpService implements IHttpService {
  private $fetch: AxiosInstance
  private $abortController: AbortController

  constructor(fetcher: AxiosInstance) {
    this.$fetch = fetcher
    this.$abortController = new AbortController()
  }

  async get<T>(url: string, data?: object): Promise<T> {
    return await this.$fetch.get(url, { ...data, signal: this.$abortController?.signal })
  }

  async post<T>(url: string, data?: object | string): Promise<T> {
    return await this.$fetch.post(url, data, { signal: this.$abortController?.signal })
  }

  abortRequests() {
    this.$abortController?.abort()
    this.$abortController = new AbortController()
  }
}

export default HttpService
